import { render, staticRenderFns } from "./pcLoft.vue?vue&type=template&id=53aed2ad&scoped=true"
import script from "./pcLoft.vue?vue&type=script&lang=js"
export * from "./pcLoft.vue?vue&type=script&lang=js"
import style0 from "./pcLoft.vue?vue&type=style&index=0&id=53aed2ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aed2ad",
  null
  
)

export default component.exports